import { CookieConsentOptions } from './utils/parseOptions'
import { setCookie } from './utils/cookies'
import triggerEvent, {
  COOKIE_SETTINGS_EVENT,
  TRIGGER_AND_CLOSE_MODAL_EVENT,
} from './utils/triggerEvent'
import {
  getCookieConsentOptions,
  getCookieSettingsOptions,
} from './utils/options'
import getCookieSettings, {
  COOKIE_SETTINGS_NAME,
} from './utils/getCookieSettings'
// import CookieSettings from './CookieSettings'
import './CookieConsent.scss'

export default class CookieConsent {
  static self: CookieConsent
  _isOpen = false
  options: CookieConsentOptions

  constructor() {
    this.options = getCookieConsentOptions()
    this.render()
  }

  static getInstance() {
    const self = this.self || new CookieConsent()
    this.self = self
    self.render()
    // CookieSettings.getInstance()
    return self
  }

  private render() {
    const {
      acceptButtonText,
      bodyTextHtml,
      containerClassName,
      declineButtonText,
      titleTextHtml,
      color,
      denyPageHref,
    } = this.options
    if (this._isOpen) return
    this._isOpen = true

    const denyButton = denyPageHref
      ? `<a href="${denyPageHref}" class="ta-cc-modal-button light">{{deny}}</a>`
      : `<button type="input" class="ta-cc-modal-button light" id="ta-cc-modal-settings">{{deny}}</button>`
    const template =
      `<div id="ta-cc-modal" class="ta-cc-modal {{className}}"><div class="ta-cc-reject"><button type="button" class="ta-cc-modal-button light">Continua senza accettare</button></div><div class="ta-cc-modal-title">{{title}}</div><div class="ta-cc-modal-body">{{content}}</div><div class="ta-cc-modal-footer">${denyButton}<button type="input" class="ta-cc-modal-button" id="ta-cc-modal-accept" style="background-color: ${color};border: 1px solid ${color}">{{accept}}</button></div></div>`
        .replace('{{title}}', titleTextHtml)
        .replace('{{content}}', bodyTextHtml)
        .replace('{{accept}}', acceptButtonText)
        .replace('{{deny}}', declineButtonText)
        .replace('{{className}}', containerClassName)

    $(template).appendTo('body')
    $('body').addClass('ta-cc-modal-open')

    $('#ta-cc-modal-accept').on('click', () => {
      // solo se sto esplicitamente cliccando l'accept, allora recupero i cookieSettings
      const cookieSettings = getCookieSettings()
      setCookie(COOKIE_SETTINGS_NAME, JSON.stringify(cookieSettings))
      this.close()
      triggerEvent(TRIGGER_AND_CLOSE_MODAL_EVENT)
    })

    $('#ta-cc-modal-settings').on('click', () => {
      this.close()
      triggerEvent(COOKIE_SETTINGS_EVENT)
    })

    $('.ta-cc-reject > button.light').on('click', () => this.refuseAllCookies())
  }

  private refuseAllCookies() {
    const options = getCookieSettingsOptions()
    const { cookieName } = getCookieConsentOptions()
    const newCookies = options.settings
      .filter(({ id }) => !!id)
      .reduce((prev, { id }) => {
        return { ...prev, [id]: false }
      }, {})
    setCookie(COOKIE_SETTINGS_NAME, JSON.stringify(newCookies))
    setCookie(cookieName, true)
    window.location.reload()
  }

  private close() {
    $('body').removeClass('ta-cc-modal-open')
    $('#ta-cc-modal').remove()
    this._isOpen = false
  }
}
